module.exports = __webpack_public_path__ + "img/meinelektromobil.918e577a.svg";